import React from "react";

const statusBadgeClassMap = {
  active: "border border-[#22C55E] bg-[#22C55E33] text-[#22C55E]",
  inactive: "border border-[#FF0000] bg-[#FF00001F] text-[#FF0000]",
  pending: "border border-[#EFA51C] bg-[#EFA51C1F] text-[#EFA51C]",
  flagged: "border border-[#FDF63B] bg-[#FDF63B33] text-[#B89B00]",
};

const StudentProfileHeader = ({
  title = "Student Profile",
  name = "Student",
  displayId = "-",
  status = "Active",
  profilePicture = "",
  onBack,
  actions = null,
}) => {
  const initials = name
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0])
    .join("")
    .toUpperCase();


  const statusKey = (status || "").toLowerCase();
  const statusClass =
    statusBadgeClassMap[statusKey] || statusBadgeClassMap.active;

  return (
    <section className="border border-[#6055555E] bg-white px-4 pb-8 pt-8 sm:px-6 sm:pb-10 sm:pt-10 desktop:px-7 desktop:pb-11 desktop:pt-14">
      <div className="flex items-center gap-4 sm:gap-6 desktop:gap-11">
        <button
          type="button"
          aria-label="Go back"
          className="shrink-0 text-[#4A4A68]"
          onClick={onBack}
        >
          <svg width="10" height="23" viewBox="0 0 10 23" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2.03946 11.4071L9.04143 20.8646C9.19995 21.0788 9.28901 21.3693 9.28901 21.6722C9.28901 21.975 9.19995 22.2655 9.04143 22.4797C8.88291 22.6938 8.6679 22.8142 8.44372 22.8142C8.21953 22.8142 8.00453 22.6938 7.84601 22.4797L0.248022 12.2146C0.169402 12.1087 0.107027 11.9828 0.0644669 11.8442C0.0219073 11.7057 0 11.5571 0 11.4071C0 11.2571 0.0219073 11.1085 0.0644669 10.9699C0.107027 10.8314 0.169402 10.7055 0.248022 10.5996L7.84601 0.334485C8.00453 0.120318 8.21953 0 8.44372 0C8.6679 0 8.88291 0.120318 9.04143 0.334485C9.19995 0.548653 9.28901 0.839126 9.28901 1.142C9.28901 1.44488 9.19995 1.73536 9.04143 1.94952L2.03946 11.4071Z" fill="#4A4A68" />
          </svg>
        </button>
        <h2 className="text-xl font-medium leading-[26px] text-black sm:text-[22px]">
          {title}
        </h2>
      </div>

      <div className="mt-5 flex flex-col gap-4 pr-0 sm:mt-7 sm:flex-row sm:items-end sm:justify-between sm:pr-3">
        <div className="flex min-w-0 flex-wrap items-start gap-3 sm:gap-[18px]">
          <div className="flex min-w-0 gap-[5px]">
            <div className="flex h-[54px] w-[54px] shrink-0 items-center justify-center overflow-hidden rounded-full bg-[#1F2937] text-xl font-semibold text-white">
              {profilePicture ? (
                <img
                  src={profilePicture}
                  alt={name}
                  className="h-full w-full object-cover"
                />
              ) : (
                initials
              )}
            </div>
            <div className="min-w-0">
              <p className="truncate text-xl font-semibold capitalize leading-7 text-black sm:text-2xl">
                {name}
              </p>
              <p className="text-base leading-5 text-[#938A96] sm:text-lg">{displayId}</p>
            </div>
          </div>

          <div className="mt-1 flex flex-wrap items-center gap-3 sm:gap-[18px]">
            <span
              className={`rounded-full px-[13px] py-[3px] text-xs capitalize leading-[14px] ${statusClass}`}
            >
              {status}
            </span>
          </div>
        </div>

        {actions ? (
          <div className="flex shrink-0 items-center gap-3">{actions}</div>
        ) : null}
      </div>
    </section>
  );
};

export default StudentProfileHeader;
